// Started from shadcn/ui (new-york-v4) "skeleton", restyled to Union. First loads only; on a
// refresh keep showing the data you have (DESIGN.md: loading and offline).

import { cn } from "@union/ui/lib/utils";
import type * as React from "react";

function Skeleton({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="skeleton"
      aria-hidden="true"
      className={cn("animate-pulse rounded-sm bg-muted motion-reduce:animate-none", className)}
      {...props}
    />
  );
}

export { Skeleton };
